import { render } from "./terms-of-use.vue?vue&type=template&id=4fe438a5&scoped=true"
import script from "./terms-of-use.vue?vue&type=script&lang=js"
export * from "./terms-of-use.vue?vue&type=script&lang=js"

import "./terms-of-use.vue?vue&type=style&index=0&id=4fe438a5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe438a5"]])

export default __exports__